import { forwardRef, ForwardedRef } from 'react';
import { isMobile } from '@direct-frontend/platform-code';
import { genericMemo } from '@direct-frontend/stdlib';

import { AlertLineSlideProps } from '../types';
import { cn } from '../../../lib/css/className/className';

import { AlertLineSlideMobile } from './AlertLineSlideMobile/AlertLineSlideMobile';
import { AlertLineSlideDesktop } from './AlertLineSlideDesktop/AlertLineSlideDesktop';

import './AlertLineSlide.css';

const cls = cn('AlertLineSlide');

export const AlertLineSlide = genericMemo(
    forwardRef(function AlertLineSlide(props: AlertLineSlideProps, ref: ForwardedRef<HTMLDivElement>) {
        const {
            'data-testid': dataTestId = 'AlertLineSlide',
            className,
            color,
            caption,
            title,
            actionIcon,
            buttonGroup,
            titleAddonLeft,
            isTitleTruncated,
            textAlign,
        } = props;

        return (
            <div data-testid={dataTestId} className={cls('', [className])} ref={ref}>
                {isMobile() ? (
                    <AlertLineSlideMobile
                        color={color}
                        caption={caption}
                        title={title}
                        actionIcon={actionIcon}
                        buttonGroup={buttonGroup}
                        textAlign={textAlign}
                        isTitleTruncated={isTitleTruncated}
                    />
                ) : (
                    <AlertLineSlideDesktop
                        color={color}
                        caption={caption}
                        title={title}
                        actionIcon={actionIcon}
                        buttonGroup={buttonGroup}
                        titleAddonLeft={titleAddonLeft}
                    />
                )}
            </div>
        );
    }),
);
